import { useState } from 'react'

import {
  Typography,
  // Spin
} from 'antd'
// import { LoadingOutlined } from '@ant-design/icons'
import MobilesTableModal from './modal/MobilesTableModal'

// const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

const CommonBox = ({ title, description, viewDetails, apiCall }) => {
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState(null)

  const onShow = async () => {
    setData(null)
    setVisible(true)
    let res = await apiCall()
    setData(res?.data)
  }
  return (
    <div className='stats'>
      <Typography.Title level={5}>{title}</Typography.Title>
      <Typography.Text>
        {' '}
        {!description || description == 'Rs. NaN' ? '0' : description}
      </Typography.Text>
      <div className='view-div'>
        {viewDetails && <p onClick={() => onShow()}>View Customers</p>}
        <MobilesTableModal title={title} data={data} visible={visible} setVisible={setVisible} />
      </div>
    </div>
  )
}

export default CommonBox
